export class TrashConfig {
    id: number;
    name: string; // AKA texture
    animates?: boolean;
    frame?: number;
    src?: string;
    frameWidth?: number;
    frameHeight?: number;
    depth?: number;

    public static TRASH: TrashConfig[] = [
        { id: 0, name: "tire", src: require("src/assets/qci/sprites/gameOceanCleanup/tire.png"), animates: true },
        { id: 1, name: "bottle", src: require("src/assets/qci/sprites/gameOceanCleanup/bottle.png"), animates: true },
        { id: 2, name: "bag", src: require("src/assets/qci/sprites/gameOceanCleanup/bag.png"), animates: true },
        { id: 3, name: "barrel", src: require("src/assets/qci/sprites/gameOceanCleanup/barrel.png"), animates: true }
    ];

    public static IMMOBILE_TRASH: TrashConfig[] = [
        { id: 4, name: "bike", frame: 2, depth: 3 },
        { id: 5, name: "spaceship-part", frame: 0, depth: 3 },
        { id: 6, name: "fridge", frame: 1 },
        { id: 7, name: "satellite", frame: 3, depth: 3 },
        { id: 8, name: "cans", frame: 4 },
    ];
}

export class Trash extends Phaser.Physics.Arcade.Sprite {
    id: number;
    name: string;
    onBoat: boolean;

    constructor(scene: Phaser.Scene, x: number, y: number, config: TrashConfig) {
        if (config.animates != null && config.animates) {
            super(scene, x, y, config.name, 0);
        } 
        else {
            super(scene, x, y, "immobile-trash", config.frame);
        }
        this.name = config.name;
        this.id = config.id;
        this.onBoat = false;

        if(config.depth) {
            this.setDepth(config.depth);
        }
        else {
            this.setDepth(2);
        }
        scene.add.existing(this);
        scene.physics.add.existing(this);
    }

}



// WEBPACK FOOTER //
// ./src/games/OceanCleanupGame/objects/Trash.ts